export default {"src":"/_next/static/media/logo-white.ac12e796.svg","height":152,"width":349,"blurWidth":0,"blurHeight":0};